import React from "react"
import {Button} from "antd"
import {isACensusPlace} from "../../utilsData";


export default ({onClick, selectedGeography}) => (
	<Button
		onClick={onClick}
		disabled={isACensusPlace(selectedGeography.cartoLayerId)}
		style={{marginTop: 4}}
	>
		Federal Grants
	</Button>
)
